import React from 'react';

export default function DefaultAvatar(props) {
  const {className} = props;

  return (
    <svg
      width="86"
      height="86"
      viewBox="0 0 86 86"
      className={className}
      preserveAspectRatio="xMidYMax slice"
    >
      <defs>
        <rect id="a" x="0" y="0" width="86" height="86" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#F7F8FA" xlinkHref="#a" />
        <path fill="#A6B0BD" fillRule="nonzero" d="M43.482 50.485c-7.038 0-12.743-5.705-12.743-12.742C30.74 30.705 36.444 25 43.482 25c7.037 0 12.742 5.705 12.742 12.743 0 7.037-5.705 12.742-12.742 12.742zM70.499 84l-1.121 5.368C66.806 101.679 55.952 110.5 43.375 110.5s-23.43-8.82-26.003-21.132L16.252 84c-1.276-6.107 1.507-30.747 27.316-30.747 25.81 0 28.008 25.406 26.93 30.747z" mask="url(#b)" />
      </g>
    </svg>

  )
}



// WEBPACK FOOTER //
// ./src/components/controls/DefaultAvatar.jsx